import { motion } from 'framer-motion';

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = '' }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-60px' }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines = [], className = '', lineClassName = '', delay = 0, inView = false }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <div key={i} className="overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.div
          className={lineClassName}
          initial={{ y: '112%' }}
          {...(inView
            ? { whileInView: { y: '0%' }, viewport: { once: true, margin: '-40px' } }
            : { animate: { y: '0%' } })}
          transition={{ duration: 0.9, delay: delay + i * 0.13, ease: EASE }}
        >
          {line}
        </motion.div>
      </div>
    ))}
  </div>
);

export const SectionHeading = ({ eyebrow, title, description, dark = false, number }) => (
  <div className="max-w-2xl">
    <Reveal>
      <p className={`flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] ${dark ? 'text-gold' : 'text-crimson'}`}>
        {number && <span className={`font-display text-lg italic ${dark ? 'text-cream/40' : 'text-navy/30'}`}>{number}</span>}
        <span className={`h-px w-8 ${dark ? 'bg-gold' : 'bg-crimson'}`} aria-hidden="true" />
        {eyebrow}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className={`mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.1] ${dark ? 'text-cream' : 'text-navy'}`}>
        {title}
      </h2>
    </Reveal>
    {description && (
      <Reveal delay={0.16}>
        <p className={`mt-5 text-base sm:text-lg leading-relaxed ${dark ? 'text-cream/70' : 'text-navy/70'}`}>{description}</p>
      </Reveal>
    )}
  </div>
);
